import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic"
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    subjectUpdate : 'SUBJECT_UPDATE',
    subjectDelete : 'SUBJECT_DELETE'
};

const mutations = {}; 
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        subject: [],
        subjectLoading: false,
        subjectError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SUBJECT (state, subject) {
            state.subject = subject;
        },

        SUBJECT_LOADING (state, loading) {
            state.subjectLoading = loading;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBJECT_ERROR(state, error) {
            state.submitError = error;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async updateSubject({commit, state, dispatch}, payload) {
            let response = '';
            await performNetworkCall(
                commit,
                keyList.countryUpdate,
                async () => {
                    let payloadData={
                        name: payload.name,
                    }
                    let magic=encode(payloadData)
                    response = await axios.post(V1API.update_subject+"/"+payload.id,magic.encodedPayload,magic.config).then(result => {
                        let data=decode(result.data)
                        return data.message
                    })

                    dispatch('fetchSubject');

                }
            )
            return response
        },

        async deleteSubject({commit, state, dispatch}, payload) {
            let response='';
            await performNetworkCall(
                commit,
                keyList.countryDelete,
                async () => {

                    response = await axios.delete(V1API.delete_subject + payload).then(result=>{
                        let data=decode(result.data)

                        return data.message

                    });
                    dispatch('fetchSubject');
                }
            )
            return response
        },

        async fetchSubject ({ commit },payload) {
            commit('SUBJECT_LOADING', true);
            commit('SUBJECT_ERROR', false);
            try{

                let result = await axios.get(V1API.fetch_subject);
                let response=decode(result.data.data)
                commit('SET_SUBJECT', response); 

            }catch(error) {

                commit('SUBJECT_ERROR', true);

            }
            commit('SUBJECT_LOADING', false);
        },

        async createSubject({commit,dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.create_subject,magic.encodedPayload,magic.config).then(result=>{
                    let data=decode(result.data)

                    return data.message

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchSubject')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

    },
    
    getters: {}
}